import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';

export const enquiryContainerCss = css({
  margin: '72px 0 32px',
  [MediaQueries.mdAndUp]: {
    margin: '56px 0 40px',
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 71,
  },
});

export const closeButtonCss = css({
  top: 24,
  [MediaQueries.mdAndUp]: {
    top: 56,
  },
});
